// extracted by mini-css-extract-plugin
export default {"wrapper":"Cq-z","response":"Dq-z","error":"Eq-z","disabled":"Fq-z","buttons":"Gq-z","feedbackQuestionSection":"Hq-z","yesNoWrapper":"Iq-z"};